<template>
  <div
    :class="[
      'table-block-wrapper position-relative pb-3',
      sidebarOpen ? 'table-block' : 'table-block-fluid',
    ]"
  >
    <table :class="['table table-striped w-100 mb-0']">
      <thead>
        <tr>
          <th v-for="col in cols" :key="col">{{ col }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, _) in rows" :key="_">
          <td v-for="(col, _) in row" :key="_">
            <span @click="onInternalLinkClick" v-html="col"></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script lang="ts" setup>
import {SphereBlock} from '@/stores/apolloPlatform/cores/portalNavigation';
import {useInternalLinks} from '@/composables/useInternalLinks';
const {block} = defineProps<{block: SphereBlock<'table_block'>}>();
const {onInternalLinkClick} = useInternalLinks();

import {applicationShellKey} from '@/components/root/shell/injectionKeys';
const sidebarOpen = inject(applicationShellKey);

// Table needs to match the rudimentary .md-body one for the moment.
const cols = block.value.columns.map((c) => c.heading);
const rows = block.value.rows.map((c) => c.values);
</script>
<style lang="scss">
/**
 * Idea & rough CSS stolen from Confluence.
 * N.B. only for prose containers that centre text.
 */
$margin: calc(calc(100vw - var(--shell-sidebar-width) - 75ch) / 2);
$margin-fluid: calc(calc(100vw - 75ch) / 2);
$width: calc(100vw - 3rem);

.container-prose {
  .table-block {
    width: calc($width - var(--shell-sidebar-width));
    left: calc(min(0px, calc(0px - $margin + 0.5rem)));
  }

  .table-block-fluid {
    width: $width;
    left: calc(min(0px, calc(0px - $margin-fluid + 0.5rem)));
  }
}

@media only screen {
  /* Be careful of this element's overflow for print  */
  .table-block-wrapper {
    overflow-x: auto;
  }
}

@media print {
  .table-block-wrapper {
    break-before: page;
    break-after: page;
  }
}
</style>
